import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ChairpersonAccountRecovery } from '@/components/auth'
import { ROUTES } from '@/constants'

export const ChairpersonAccountRecoveryPage = () => {
  const navigate = useNavigate()

  const onSuccess = () => {
    navigate(ROUTES.CHAIRPERSON_DASHBOARD)
  }

  const onBack = () => {
    navigate(ROUTES.CHAIRPERSON_LOGIN)
  }

  return <ChairpersonAccountRecovery onSuccess={onSuccess} onBack={onBack} />
}
